import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'
import { Layout, Text } from '@loadsmart/miranda-react'

import { isMultiStop } from 'core/domain/Stop'

import { screen } from 'legacy/styles/screen'

import { type StopInfo } from '../../../domain/StopInfo'
import { ExtraStopInformation } from './ExtraStopInformation'
import { StopInformation } from './StopInformation'

const Divider = styled.div`
  background: ${getToken('color-neutral-light')};
  height: ${getToken('space-2xs')};
  width: ${getToken('space-xl')};
  display: none;

  ${screen.md} {
    display: block;
  }
`

export type LaneInformationProps = {
  stops: StopInfo[]
  mileage?: number
  disabled?: boolean
}

export function LaneInformation({ stops, mileage, disabled = true }: LaneInformationProps) {
  const stopsLength = stops.length

  if (stopsLength <= 1) return null

  const showInfo = Boolean(mileage) || isMultiStop(stopsLength)

  const firstStop = stops[0]
  const lastStop = stops[stopsLength - 1]

  return (
    <Layout.Group align="center" gap="spacing-5">
      <StopInformation stop={firstStop} disabled={disabled} />
      <Divider />
      {showInfo && (
        <Layout.Group gap="spacing-5" align="center">
          <Layout.Stack gap="spacing-1">
            {Boolean(mileage) && <Text variant="body-md-bold">{`${mileage} mi`}</Text>}
            <ExtraStopInformation stops={stops.slice(1, -1)} />
          </Layout.Stack>
          <Divider />
        </Layout.Group>
      )}
      <StopInformation stop={lastStop} disabled={disabled} />
    </Layout.Group>
  )
}
